
import { format } from 'date-fns'
export default {
  name: 'BlogDetailPage',
  middleware: ['checkLocalStorage'],
  data() {
    return {
      urlEtaxWebPortal: process.env.urlEtaxWebPortal,
      urlEtaxPackage: process.env.urlEtaxPackage,
      urlEtaxSP: process.env.urlEtaxSP,
      urlEtaxRegister: process.env.urlEtaxRegister,
      urlHostname: process.env.urlHostname,
      itemsPath: [
        {
          text: 'หน้าหลัก',
          disabled: false,
          href: '/',
        },
        {
          text: 'ข่าวสาร/บทความ',
          disabled: false,
          href: '/blog',
        },
      ],
      itemsSocial: [
        {
          text: 'facebook',
          alt: 'Facebook',
          image: require('@/static/logo-social/facebook.png'),
        },
        {
          text: 'line',
          alt: 'Line',
          image: require('@/static/logo-social/line.png'),
        },
        {
          text: 'twitter-x',
          alt: 'Twister X',
          image: require('@/static/logo-social/twitter.png'),
        },
        {
          text: 'copy-link',
          alt: 'Copy Link',
          image: require('@/static/logo-social/chain.png'),
        },
      ],
      loadContent: true,
      foundcontent: false,
      dataContent: {},
      itemBlog: [],
      totalBlog: 0,
      perPage: 100,
      page: 1,
      redirectTime: 3,
    }
  },
  head() {
    return this.$headUtil({
      lang: 'en',
      title: this.dataContent.blog_title || '-',
      description: '-',
      urlPath: this.$route.fullPath,
    })
  },
  computed: {
    contentHtml() {
      let content = this.dataContent.blog_content
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        content = this.dataContent.blog_content.replaceAll(/h1|h2|h3|h4/g, 'h5')
        return content
      } else {
        return content
      }
    },
  },
  mounted() {
    this.fn_loadBlogContent()
  },
  methods: {
    async fn_loadBlogContent() {
      try {
        this.loadContent = true
        const payload = {
          path: this.$route.params.path,
        }
        const callApi = await this.$axios.post(
          process.env.apiWebContent + 'getContentDetail',
          payload
        )
        // console.log(callApi.data)

        if (callApi.data.status === 'OK') {
          this.foundcontent = true
          this.dataContent = callApi.data.result
          this.itemsPath.push({
            text: this.dataContent.blog_title,
            disabled: true,
            href: '/blog/' + this.$route.fullPath,
          })
        } else {
          this.foundcontent = false

          const intervalId = setInterval(() => {
            if (this.redirectTime > 0) {
              this.redirectTime -= 1
            } else {
              clearInterval(intervalId)
              this.$router.push('/blog')
            }
          }, 1000)
        }
        this.loadContent = false
      } catch (err) {
        this.loadContent = false
        this.foundcontent = false
        console.log(err)
      }
    },

    fn_formatDatetime(_datetime, _format) {
      return format(new Date(_datetime), _format)
    },
    fn_goto(_path, _mode, _newtab) {
      // console.log(_path, _mode, _newtab)
      if (_mode === 'external') {
        if (_newtab === true) {
          window.open(_path, '_blank')
        } else {
          window.location.assign(_path)
        }
      } else {
        this.$router.push(_path)
      }
    },
    fn_social_media(_social) {
      console.log('object :>> ', _social)
      if (_social === 'facebook') {
        window.open(
          'https://www.facebook.com/sharer/sharer.php?u=' +
            'https://etax.one.th/blog/' +
            this.dataContent.blog_path_directory,
          '_blank'
        )
      } else if (_social === 'line') {
        window.open(
          'https://social-plugins.line.me/lineit/share?url=' +
            'https://etax.one.th/blog/' +
            this.dataContent.blog_path_directory,
          '_blank'
        )
      } else if (_social === 'twitter-x') {
        window.open(
          'https://twitter.com/intent/tweet?url=' +
            'https://etax.one.th/blog/' +
            this.dataContent.blog_path_directory,
          '_blank'
        )
      } else if (_social === 'copy-link') {
        const path = window.location.pathname
        navigator.clipboard.writeText(path)
      }
    },
  },
}
